import React from 'react';
import { compose } from 'redux';
import anime from 'animejs/lib/anime.es.js';

import Index from './_index';


class Journals extends React.Component {
    constructor(props) {
        super(props);
        setTimeout(() => {
            window.scrollTo(1000, 0);
        }, 300);
    }
    componentdidupdate(){
        setTimeout(() => {
            window.scrollTo(1000, 0);
        }, 300);
    }

    componentDidMount(){
      
        var titles = document.querySelectorAll('.journal--articles article');
        var figs = document.querySelectorAll('.journal--figures figure');

        titles[0].classList.add("active");
        titles[0].style['opacity'] = 1;

        [...figs].forEach((item, index) => {   
            if(index > 0) {
                if(item.querySelector('img')){
                    let elem = item.querySelector('img').style['opacity'] = 0.5;
                }
                
            }
        });

        let _this = this;
        window.addEventListener('scroll', function() {
                
            if(document.querySelector('.mole__journal--insta')){
                let elementTop = document.querySelector('main > .mole__menu').getBoundingClientRect().height;
                let windowHeight = window.innerHeight;
                let viewportTop = document.documentElement.scrollTop;
                let pageHeight = document.body.clientHeight;
                let jArticles = document.querySelector('.journal--articles');
                let pageHeading = document.querySelector('.--title');

                if((viewportTop + windowHeight ) >= (pageHeight - elementTop)){
                    jArticles.style['opacity'] = 0;
                }
                else{
                    jArticles.style['opacity'] = 1;
                }

                if((viewportTop + (windowHeight / 2.5) ) >= (pageHeight - elementTop)){
                    pageHeading.style['opacity'] = 0;
                }
                else{
                    pageHeading.style['opacity'] = 1;
                }
            }
            _this.handleScroll()
            
        });
        
        [...figs].forEach((item, index) => {   
            let elem = item.querySelector('img');
            if(elem){
                elem.addEventListener('mouseenter',(e) =>{
                    e.preventDefault();
                    let figIndex = e.currentTarget.parentElement.dataset.index;
    
                    [...figs].forEach((item, index) => {   
                        if(item.querySelector('img')){
                            let elem = item.querySelector('img').style['opacity'] = 0.5;
                        }                        
                    });
    
                    
                    [...titles].forEach((item, key) => {
                        item.style['opacity'] = 1;
                        // item.classList.remove('active');
                        //elem.classList.remove('fade-out');
                        if(Number(key) === Number(figIndex)){
                           item.classList.add('active');
                           //elem.classList.add('fade-out');
                        }
                   })
                })
            }
          
            item.addEventListener('mouseleave',(e) =>{
                //console.log(1)
                e.preventDefault();
                _this.handleScroll()
            })
        })
        
    }    
    handleScroll(){
        var titles = document.querySelectorAll('.journal--articles article');
        var figs = document.querySelectorAll('.journal--figures figure');

        //Filter out all figures below mid window
        let actvFigsArr = [...figs].filter((fig, index) => {
            if(fig.querySelector('img')){
                fig.querySelector('img').style['opacity'] = 0.5;
                let figBottom = fig.getBoundingClientRect().bottom;
                let windowHeight = window.innerHeight
                || document.documentElement.clientHeight
                || document.body.clientHeight;
                let mid = Number(windowHeight)/2;
                if (figBottom >= mid) return this;
            }
         
        })
        //Index of the first one, considered as active
        let index = actvFigsArr.length ? actvFigsArr[0].dataset.index : 0;
        //figs[index].querySelector('img').style['opacity'] = 1;
        //Add active class to index of active figure 
        [...titles].forEach((item, key) => {
             item.style['opacity'] = 1;
            item.classList.remove('active');
            if( figs[key].querySelector('img')){
                figs[key].querySelector('img').classList.remove('fade-out');
                if(Number(key) === Number(index)){
                    item.classList.add('active');
                    figs[key].querySelector('img').classList.add('fade-out');
                }
            }
           
        })
        //Remove active class if scroll area overlaps the footer menu
        let lastTitle = titles[titles.length-1];
        if(lastTitle){
             let lastTitleBottom = lastTitle.getBoundingClientRect().bottom;
             let footerMenu = document.querySelectorAll('.mole__menu')[0];
             let footerMenuTop = footerMenu.getBoundingClientRect().top;
             if(footerMenuTop <= lastTitleBottom){
                 [...titles].forEach((item, key) => {
                     item.classList.remove('active');
                     figs[key].querySelector('img').classList.remove('fade-out');
                     item.style['opacity'] = 0;
                 })
             }
        }  
    }
    render() {
        let {journals} = this.props;
        return (
            <section className="mole__journal--insta">
                <div className="main-container">
                    <div className="inner-container">
                        <h2 className="font-lg-head c-general w-100 --title">Journal</h2>
                        <div className="fullW posiR">
                            <div className="journal--articles">
                                {
                                    journals.data.map((item, key) => {
                                        return (
                                            <article>
                                                <h6 className="c-general">{item.date}</h6>
                                                <p>{item.caption}</p>
                                            </article>
                                        )
                                    })
                                }
                            </div>

                            <div className="journal--figures">
                                {
                                    journals.data.map((journal, key) => {
                                        return (
                                            <figure data-index={key}>
                                                <a href={journal.link} target="_blank">
                                                    {
                                                        journal.media_type == 'VIDEO' ?
                                                            <video muted="" loop="" playsinline="" poster="" controls>
                                                                <source src={journal.media_url} type="video/mp4" />
                                                            </video>
                                                        : <img parallax="{translateY: ['0vh', '0']}" src={journal.media_url} alt="Michaelis Boyd" />

                                                    }
                                                </a>  
                                                <figcaption>
                                                    <h6 className="c-general">{journal.date}</h6>
                                                    <p>{journal.caption.slice(0, 115)}</p>
                                                </figcaption>
                                            </figure>
                                        )
                                    })
                                }
                            </div>
                   
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
export default Journals;



// WEBPACK FOOTER //
// ./src/components/Journal/Journals.js